import { forwardRef, TextareaHTMLAttributes } from "react";
import { useFormFieldState } from "../FormComponentHooks";
import styles from "./FormField.module.less";
import { extractValueProps, FormFieldProps } from "./FormFieldProps";

export type TextareaProps =
  & TextareaHTMLAttributes<HTMLTextAreaElement>
  & FormFieldProps<string>;

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  function Textarea(props, ref) {
    const [valueProps, { ...textareaProps }] = extractValueProps(props);
    const [value, setValue] = useFormFieldState(valueProps, "");

    return (
      <textarea
        ref={ref}
        className={styles.textarea}
        rows={3}
        {...textareaProps}
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
    );
  },
);
